import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import GenericFormItem from '../GenericFormItem';

class SelectFieldComponent extends Component {
  constructor(props) {
    super();

    this.state = {
      val: props.val || _.get(props, 'form.choices[0].key'),
    };
  }

  render() {
    const {
      label,
      form,
      name,
      disabled,
      onChange,
      edit,
    } = this.props;

    const menuItems = _.map(form.choices, (item, i) => (
      <MenuItem value={item.key} key={i} primaryText={item.label} />
    ));

    const handleChange = (val) => {
      this.setState({ val }, () => onChange(name, val));
    };

    const selected = _.find(form.choices, { key: this.state.val });

    const fieldComponent = (
      <SelectField
        value={this.state.val}
        onChange={(event, index, val) => handleChange(val)}
        fullWidth
        name={label}
        disabled={disabled}
      >
        {menuItems}
      </SelectField>);

    return (
      <GenericFormItem label={label}>
        {edit ? fieldComponent : selected.label}
      </GenericFormItem>
    );
  }
}

SelectFieldComponent.propTypes = {
  val: PropTypes.string,
  form: PropTypes.objectOf(PropTypes.any),
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  edit: PropTypes.bool,
};

export default SelectFieldComponent;



// WEBPACK FOOTER //
// ./src/components/FormConfigs/SelectField.js